import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { OXYGEN_RIDE_DETAILS_NOTE } from '../../../constants/constants';
import styles from './index.module.css';

const OxygenImportantInfo = ({ message = OXYGEN_RIDE_DETAILS_NOTE }) => (
  <div className={styles.container}>
    <div className={styles.badge}>
      <InfoCircleOutlined className={styles.icon} />
      <span>Important Info</span>
    </div>
    <div className={styles.content}>
      {message}
    </div>
  </div>
);

export default OxygenImportantInfo;
